import React, { useState } from 'react';

import { Popover } from '@mantine/core';
import { useWindowSize } from 'react-use';
import menuicon from 'assets/icons/menudots.svg';

import DeleteFolder from './DeleteFolder';

const FolderPopover = ({ mail }) => {
  const { width } = useWindowSize();

  //popover size
  function popoversize() {
    if (width >= 1280 && width <= 1535) {
      return 'lg';
    } else if (width >= 1536) {
      return 'xl';
    } else {
      return 'lg';
    }
  }
  const size = popoversize();
  const [isFolderPopoverOpened, setIsFolderPopoverOpened] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div>
      <Popover
        opened={isFolderPopoverOpened}
        onClose={() => setIsFolderPopoverOpened(false)}
        width={size}
        position='bottom-end'
        target={
          <div className=' cursor-pointer'>
            <img
              src={menuicon}
              alt='menu'
              className='cursor-pointer h-4 '
              onClick={() => setIsFolderPopoverOpened(true)}
            />
          </div>
        }
      >
        <div className='bg-FFFFFF font-normal text-000000 text-sm 2xl:text-lg 3xl:text-2xl w-32 2xl:w-40 3xl:w-48'>
          <p
            className='p-1.5 cursor-not-allowed opacity-50  hover:bg-F8F7F7'
            onClick={() => {
              setIsFolderPopoverOpened(false);
              // console.log('modal opened');
            }}
          >
            Rename
          </p>

          <p
            className={`
             p-1.5 cursor-not-allowed opacity-50 hover:bg-F8F7F7`}
            onClick={() => {
              setIsFolderPopoverOpened(false);
            }}
          >
            Edit members
          </p>

          <p
            className='p-1.5 cursor-pointer  hover:bg-F8F7F7'
            onClick={() => {
              setIsFolderPopoverOpened(false);
              setIsModalOpen(true);
            }}
          >
            Delete folder
          </p>
        </div>
      </Popover>
      <DeleteFolder
        folderId={mail?.id}
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
      />
    </div>
  );
};

export default FolderPopover;
